module.exports = __webpack_public_path__ + "static/media/kindergartenServicesBg.fc76db80.png";